import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
const included = ['15 Complete Volumes (All Age Groups)', '6 Strategic Bonuses (Worth $328)', '208 Structured Practice Weeks', '100+ Professional Drill Cards', 'Player Assessment & Tracking System', 'Printable Practice Sheets — Ready to Use', 'Lifetime Access — Instant Download'];
export function Offer() {
  return <section id="pricing" className="border-b border-line bg-ink-800 py-16 md:py-24" aria-labelledby="offer-title" data-id="element-124" data-mp="u0xvtwg7a92z">
      <div className="mx-auto max-w-4xl px-5 md:px-8" data-id="element-125" data-mp="13x16jqp4bg1j">
        <div className="rounded-xl border border-accent/40 bg-accent/10 p-6 text-center md:p-8" data-id="element-126" data-mp="13ym13gbfmyze">
          <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-accent md:text-3xl" data-id="element-127" data-mp="ywd50b39jgt2">
            ⏰ Limited-Time Offer
          </p>
          <p className="mt-2 text-sm text-slate-200 md:text-base" data-id="element-128" data-mp="2admmwt6qu0s9">
            Launch price ends soon — after that, the price increases and bonuses are removed.
          </p>
          <div className="mt-6" data-id="element-129" data-mp="pml6bh9bn9ao">
            <Countdown data-id="element-130" data-mp="uiiqjynpgzsq" />
          </div>
          <p className="mt-6 text-sm font-bold uppercase tracking-[0.12em] text-white" data-id="element-131" data-mp="uhh2mtllcitl">
            🔴 Limited spots — 72% claimed
          </p>
          <div className="mx-auto mt-3 h-2 w-full max-w-md overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Spots claimed" data-id="element-132" data-mp="13jqepnwick93">
            <div className="h-full w-[72%] rounded-full bg-accent" data-id="element-133" data-mp="fufk6o5r3m3e" />
          </div>
        </div>

        <h2 id="offer-title" className="mt-14 text-center font-display text-3xl font-extrabold uppercase leading-tight text-white md:text-5xl" data-id="element-134" data-mp="kl485ti820xs">
          Limited-Time Offer — Everything Included, One Single Price.
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-line bg-ink" data-id="element-135" data-mp="3o8o477u7j4jy">
          <div className="border-b border-line bg-ink-700 px-6 py-5 text-center md:px-10" data-id="element-136" data-mp="vepbv4sad9wr">
            <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-3xl" data-id="element-137" data-mp="qfmf07mgm9zv">
              ⚾ Baseball 360 — Complete Vault
            </p>
            <p className="mt-1 text-sm text-slate-300" data-id="element-138" data-mp="106phndv1ex19">
              15 Volumes + 6 Bonuses — Full System
            </p>
          </div>

          <div className="grid gap-8 p-6 md:grid-cols-[1.1fr_0.9fr] md:p-10" data-id="element-139" data-mp="cho2l7rp8nn0">
            <ul className="space-y-3" data-id="element-140" data-mp="7ila0mswo9vx">
              {included.map(item => <li key={item} className="flex items-start gap-3 text-sm text-slate-200 md:text-base" data-id="element-141" data-mp="lhb21o0vbjdf">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-142" data-mp="hfg3grabnk3c" />
                  {item}
                </li>)}
            </ul>

            <div className="flex flex-col items-center justify-center rounded-xl border border-line bg-ink-800 p-6 text-center" data-id="element-143" data-mp="1sv4rllzbap5q">
              <p className="text-sm text-slate-400" data-id="element-144" data-mp="20edzfas66fso">
                Total value: <s data-id="element-145" data-mp="25dqp03afe0yy">$90</s>
              </p>
              <p className="mt-1 font-display text-7xl font-extrabold leading-none text-white md:text-8xl" data-id="element-146" data-mp="25es2eeewyzju">
                $27
              </p>
              <p className="mt-1 text-sm text-slate-400" data-id="element-147" data-mp="1qiu8z3wdk9bb">one-time payment</p>
              <p className="mt-4 rounded-md bg-emerald-500/15 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-emerald-400" data-id="element-148" data-mp="1vfsz7bcx3w48">
                Save $63 today
              </p>
            </div>
          </div>

          <div className="border-t border-line px-6 py-8 text-center md:px-10" data-id="element-149" data-mp="2o62n2du1qg3a">
            <div className="flex justify-center" data-id="element-150" data-mp="29f27louvtlxn">
              <CtaButton data-id="element-151" data-mp="2edn5viqkpvjg">🚀 I want Baseball 360 now</CtaButton>
            </div>
            <div className="mt-4 space-y-1 text-xs text-slate-400 md:text-sm" data-id="element-152" data-mp="3249dxa0kvftg">
              <p data-id="element-153" data-mp="3226ey0hg6ccl">🔒 Secure payment · ⚡ Instant access · 🛡️ 7-Day money-back guarantee</p>
              <p data-id="element-154" data-mp="36wsqc3nj44wo">💳 Card · Google Pay · Apple Pay · PayPal</p>
              <p data-id="element-155" data-mp="1j7fq2skdllgj">💱 You'll be charged in your local currency</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}